import { Box, ButtonGroup, Grid, ListItem, Paper, Skeleton, TextField, Typography, useMediaQuery } from '@mui/material'
import React from 'react'
import DataTable from '../../components/tables/DataTable';
import { FilterTitleBox } from '../../components/layouts/OneViewBox';
import PaddingBoxInDesktop from '../../components/layouts/PaddingBoxDesktop';
import AsyncSearchBar from '../../components/inputs/AsyncSearchBar';
import { BUTTON_TYPE, STATUS } from '../../utils/constants';
import ButtonComponentsUi from './ButtonComponentsUi';
import CustomInput from '../../components/inputs/CustomInputs';
import { getProdutApi } from '../../apis/product.api';
import AsyncDropDown from '../../components/inputs/AsyncDropDown';

const DashboardPageUI = ({ productid, setProductid, loadingCount, Count, CountStatus, setSTATUSWiseData, STATUSWiseData, filters, setFilters, createTiket, setList, loading, list, columns, setRepairstatusButton, RepairstatusButton }) => {
  const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down("md"))
  const issmSmallScreen = useMediaQuery(theme => theme.breakpoints.down("sm"))
  const isSmallScreens = useMediaQuery('(max-width:1100px)');

  return (
    <>
      <Box  >
        <Paper sx={{ width: "100%", height: "100%", overflow: "auto", padding: (isSmallScreen || isSmallScreens) ? 4 : 6 }}>
          <Box>
            <FilterTitleBox >
              <Box mt={2} display={"flex"} flexDirection={"row"} justifyContent={"space-between"} width={"100%"}>
                <Box >
                  <Typography variant="h3" color={"primary"}>
                    Repair Dashboard
                  </Typography>
                </Box>

              </Box>
            </FilterTitleBox>
          </Box>

          {loadingCount ?
            <Box mt={4} sx={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', height: "15vh" }}>
              {[0, 1, 2].map((row) => (
                <Skeleton
                  key={row}
                  variant="rectangular"
                  width={!issmSmallScreen ? "32%" : "32%"}
                  height={120}
                  sx={{ borderRadius: "8px", boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)" }}
                />
              ))}
            </Box>
            : <Grid mt={4} md={12} xs={12} sm={12} container>
              <Box gap={4} sx={{ width: "100%", display: "flex", justifyContent: "space-between", flexDirection: !issmSmallScreen ? "row" : "column" }}>
                <Box width={!issmSmallScreen ? "32%" : "100%"} >
                  <ButtonComponentsUi onSubmit={() => { setRepairstatusButton(BUTTON_TYPE.Work_In_Progress); setSTATUSWiseData(STATUS.ALL) }}
                    count={((CountStatus?.response[17]?.count ?? 0) + (CountStatus?.response[12]?.count ?? 0) + (CountStatus?.response[16]?.count ?? 0) + (CountStatus?.response[11]?.count ?? 0) + (CountStatus?.response[8]?.count ?? 0) + (CountStatus?.response[13]?.count ?? 0) + (CountStatus?.response[5]?.count ?? 0) ?? 0)} STATUSTypeData={BUTTON_TYPE.Work_In_Progress} colorType={RepairstatusButton === BUTTON_TYPE.Work_In_Progress} />
                </Box>
                <Box width={!issmSmallScreen ? "32%" : "100%"} >
                  <ButtonComponentsUi onSubmit={() => { setRepairstatusButton(BUTTON_TYPE.Solved); setSTATUSWiseData(STATUS.ALL) }}
                    count={((CountStatus?.response[10]?.count ?? 0) + (CountStatus?.response[15]?.count ?? 0) + (CountStatus?.response[14]?.count ?? 0) + (CountStatus?.response[6]?.count ?? 0) ?? 0)} STATUSTypeData={BUTTON_TYPE.Solved} colorType={RepairstatusButton === BUTTON_TYPE.Solved} />
                </Box>
                <Box width={!issmSmallScreen ? "32%" : "100%"} >
                  <ButtonComponentsUi
                    count={((CountStatus?.response[17]?.count ?? 0) + (CountStatus?.response[12]?.count ?? 0) + (CountStatus?.response[16]?.count ?? 0) + (CountStatus?.response[15]?.count ?? 0) + (CountStatus?.response[8]?.count ?? 0) + (CountStatus?.response[14]?.count ?? 0) + (CountStatus?.response[13]?.count ?? 0) + (CountStatus?.response[5]?.count ?? 0) + (CountStatus?.response[10]?.count ?? 0) + (CountStatus?.response[11]?.count ?? 0) + (CountStatus?.response[6]?.count ?? 0) ?? 0)}
                    Total={"Total"}
                    STATUSTypeData
                    isPointer={true}
                  />
                </Box>
              </Box>
            </Grid>}

          {loadingCount ?
            <Box mt={5} mb={4} sx={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', width: !issmSmallScreen ? "25%" : "100%" }}>
              {[0, 1, 2, 3].map((row) => (
                <Skeleton
                  key={row}
                  variant="rectangular"
                  width={!issmSmallScreen ? "25%" : "100%"}
                  height={50}
                  sx={{ borderRadius: "8px", boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)" }}
                />
              ))}
            </Box>
            : <Box mt={4} sx={{ width: "100%", display: "flex", justifyContent: "space-between", flexDirection: !isSmallScreen ? "row" : "column" }} >

              {RepairstatusButton === BUTTON_TYPE.Work_In_Progress && <Box my={3} width={"100%"}>
                <ButtonGroup sx={{ flexDirection: !issmSmallScreen ? "row" : "column", width: "100%" }}>
                  <ButtonComponentsUi padding={2} onSubmit={() => {  setSTATUSWiseData(STATUS.ALL); setFilters({ ...filters, pageNo: 1 }) }}
                    count={(CountStatus?.response[17]?.count ?? 0) +(CountStatus?.response[12]?.count ?? 0) + (CountStatus?.response[8]?.count ?? 0) + (CountStatus?.response[5]?.count ?? 0) + (CountStatus?.response[13]?.count ?? 0) + (CountStatus?.response[16]?.count ?? 0) + (CountStatus?.response[11]?.count ?? 0)} Title={STATUS.ALL} STATUSWiseData={STATUSWiseData === STATUS.ALL} />
                  <ButtonComponentsUi padding={2} onSubmit={() => { setSTATUSWiseData(STATUS.DEVICE_RECEIVED); setFilters({ ...filters, pageNo: 1 }) }} count={CountStatus?.response[12]?.count ?? 0} Title={STATUS.DEVICE_RECEIVED} STATUSWiseData={STATUSWiseData === STATUS.DEVICE_RECEIVED} />
                  <ButtonComponentsUi padding={2} onSubmit={() => { setSTATUSWiseData(STATUS.REPAIR_START); setFilters({ ...filters, pageNo: 1 }) }} count={CountStatus?.response[8]?.count ?? 0} Title={STATUS.REPAIR_START} STATUSWiseData={STATUSWiseData === STATUS.REPAIR_START} />
                  <ButtonComponentsUi padding={2} onSubmit={() => { setSTATUSWiseData(STATUS.WAITING_FOR_PAYMENT); setFilters({ ...filters, pageNo: 1 }) }} count={CountStatus?.response[5]?.count ?? 0} Title={STATUS.WAITING_FOR_PAYMENT} STATUSWiseData={STATUSWiseData === STATUS.WAITING_FOR_PAYMENT} />
                  <ButtonComponentsUi padding={2} onSubmit={() => { setSTATUSWiseData(STATUS.PAYMENT_RECEIVED); setFilters({ ...filters, pageNo: 1 }) }} count={CountStatus?.response[13]?.count ?? 0} Title={STATUS.PAYMENT_RECEIVED} STATUSWiseData={STATUSWiseData === STATUS.PAYMENT_RECEIVED} />
                  <ButtonComponentsUi padding={2} onSubmit={() => { setSTATUSWiseData(STATUS.QC_CHECKED); setFilters({ ...filters, pageNo: 1 }) }} count={CountStatus?.response[17]?.count ?? 0} Title={STATUS.QC_CHECKED} STATUSWiseData={STATUSWiseData === STATUS.QC_CHECKED} />
                  <ButtonComponentsUi padding={2} onSubmit={() => { setSTATUSWiseData(STATUS.REPAIR_DEMO); setFilters({ ...filters, pageNo: 1 }) }} count={CountStatus?.response[16]?.count ?? 0} Title={STATUS.REPAIR_DEMO} STATUSWiseData={STATUSWiseData === STATUS.REPAIR_DEMO} />
                  <ButtonComponentsUi padding={2} onSubmit={() => { setSTATUSWiseData(STATUS.REPLACEMENT); setFilters({ ...filters, pageNo: 1 }) }} count={CountStatus?.response[11]?.count ?? 0} Title={STATUS.REPLACEMENT} STATUSWiseData={STATUSWiseData === STATUS.REPLACEMENT} />
                </ButtonGroup>
              </Box>}

              {RepairstatusButton === BUTTON_TYPE.Solved && <Box my={3}>
                <ButtonGroup sx={{ flexDirection: !issmSmallScreen ? "row" : "column", width: "100%" }}>
                  <ButtonComponentsUi padding={2} onSubmit={() => {  setSTATUSWiseData(STATUS.ALL); setFilters({ ...filters, pageNo: 1 }) }}
                  count={ (CountStatus?.response[10]?.count ?? 0) + (CountStatus?.response[6]?.count ?? 0) + (CountStatus?.response[15]?.count ?? 0) + (CountStatus?.response[14]?.count ?? 0)} Title={STATUS.ALL} STATUSWiseData={ STATUSWiseData === STATUS.ALL} />
                  <ButtonComponentsUi padding={2} onSubmit={() => { setSTATUSWiseData(STATUS.REPAIR_COMPLETED); setFilters({ ...filters, pageNo: 1 }) }} count={CountStatus?.response[10]?.count ?? 0} Title={STATUS.REPAIR_COMPLETED} STATUSWiseData={STATUSWiseData === STATUS.REPAIR_COMPLETED} />
                  <ButtonComponentsUi padding={2} onSubmit={() => { setSTATUSWiseData(STATUS.NOT_DISPATCH); setFilters({ ...filters, pageNo: 1 }) }} count={CountStatus?.response[6]?.count ?? 0} Title={STATUS.NOT_DISPATCH} STATUSWiseData={STATUSWiseData === STATUS.NOT_DISPATCH} />
                  <ButtonComponentsUi padding={2} onSubmit={() => { setSTATUSWiseData(STATUS.DEMO); setFilters({ ...filters, pageNo: 1 }) }} count={CountStatus?.response[15]?.count ?? 0} Title={STATUS.DEMO} STATUSWiseData={STATUSWiseData === STATUS.DEMO} />
                  <ButtonComponentsUi padding={2} onSubmit={() => { setSTATUSWiseData(STATUS.REPLACEMENT_COMPLETE); setFilters({ ...filters, pageNo: 1 }) }} count={CountStatus?.response[14]?.count ?? 0} Title={STATUS.REPLACEMENT_COMPLETE} STATUSWiseData={STATUSWiseData === STATUS.REPLACEMENT_COMPLETE} />
                </ButtonGroup>
              </Box>}
              {RepairstatusButton === BUTTON_TYPE.Solved && 
              <Box sx={{ display: "flex", width: isSmallScreen ? "100%" : issmSmallScreen ? "100%" : "30%", justifyContent: "center", alignItems: "center" }}>
                <Box pl={2} sx={{ display: "flex", width: "50%",}}>
                  <AsyncDropDown
                    defaultVal={
                      productid._id ? {
                        _id: productid._id,
                        name: productid.name,
                      } : null
                    }
                    size={true}
                    lazyFun={async (para) => await getProdutApi({ ...para, allStatus: true })}
                    OptionComponent={({ option, ...rest }) => {
                      return <ListItem {...rest}>{option.name}</ListItem >
                    }}
                    onChange={async (changedVal) => {
                      setProductid({ _id: changedVal?._id, name: changedVal?.name })
                    }}
                    titleKey={'name'}
                    valueKey={"_id"}
                    InputComponent={(params) => <TextField size='small' placeholder={"Select Product"} {...params} />}
                  />
                </Box>

                <Box
                  mt={1}
                  sx={{ display: "flex", width: !issmSmallScreen ? "50%" : !isSmallScreen ? "50%" : "100%" }}
                  pl={2}
                  >
                  <AsyncSearchBar
                    fullWidth
                    title="Search"
                    size="small"
                    placeholder={" Search "}
                    defaultValue={filters.search}
                    onChange={(changedVal) => {
                      setFilters({ ...filters, search: changedVal });
                    }}
                  />
                </Box>
              </Box>}
            </Box>}
          
          {RepairstatusButton === BUTTON_TYPE.Work_In_Progress && <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
            <Box sx={{ display: "flex", width: isSmallScreen ? "100%" : issmSmallScreen ? "100%" : "30%", justifyContent: "center", alignItems: "center" }}>
              <Box pl={2} sx={{ display: "flex", width: "50%", }}>
                <AsyncDropDown
                  defaultVal={
                    productid._id ? {
                      _id: productid._id,
                      name: productid.name,
                    } : null
                  }
                  size={true}
                  lazyFun={async (para) => await getProdutApi({ ...para, allStatus: true })}
                  OptionComponent={({ option, ...rest }) => {
                    return <ListItem {...rest}>{option.name}</ListItem >
                  }}
                  onChange={async (changedVal) => {
                    setProductid({ _id: changedVal?._id, name: changedVal?.name })
                  }}
                  titleKey={'name'}
                  valueKey={"_id"}
                  InputComponent={(params) => <TextField size='small' placeholder={"Select Product"} {...params} />}
                />
              </Box>

              <Box
                mt={1}
                sx={{ display: "flex", width: !issmSmallScreen ? "50%" : !isSmallScreen ? "50%" : "100%" }}
                pl={2}
              >
                <AsyncSearchBar
                  fullWidth
                  title="Search"
                  size="small"
                  placeholder={" Search "}
                  defaultValue={filters.search}
                  onChange={(changedVal) => {
                    setFilters({ ...filters, search: changedVal });
                  }}
                />
              </Box>
            </Box>
          </Box>}

          <Box overflow={"auto"} mt={2} maxHeight={"100%"} >
            <DataTable isSmallScreen={isSmallScreens} key={RepairstatusButton} customRows={true} columns={columns} rows={list?.result ? list?.result : []} count={list?.total ?? 0} filters={filters} setFilters={setFilters} loading={loading} />
          </Box>
        </Paper >
      </Box >


    </>
  )
}

export default DashboardPageUI